import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type SunIconProps = CommonSvgProps

const SunIcon: React.FC<SunIconProps> = React.forwardRef<SVGSVGElement, SunIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 24 24" {...props} ref={ref} color="none">
      <path
        d="M10.667 1.33S10.667 0 12 0s1.333 1.33 1.333 1.33v1.331s0 1.33-1.333 1.33-1.333-1.33-1.333-1.33v-1.33Zm12 9.314s1.333 0 1.333 1.331c0 1.33-1.333 1.33-1.333 1.33h-1.334s-1.333 0-1.333-1.33 1.333-1.33 1.333-1.33h1.334Zm-20 0S4 10.644 4 11.975c0 1.33-1.333 1.33-1.333 1.33H1.333S0 13.306 0 11.976s1.333-1.33 1.333-1.33h1.334ZM6.08 4.852s.942.94 0 1.881c-.943.941-1.886 0-1.886 0l-.943-.94s-.943-.94 0-1.882c.943-.94 1.886 0 1.886 0l.943.94Zm14 13.97s.942.941 0 1.882c-.943.94-1.886 0-1.886 0l-.942-.94s-.943-.941 0-1.882c.942-.94 1.885 0 1.885 0l.943.94Zm-.276-12.089s-.942.941-1.885 0c-.943-.94 0-1.881 0-1.881l.943-.94s.942-.942 1.885 0c.943.94 0 1.88 0 1.88l-.943.941Zm-14 13.971s-.942.94-1.885 0c-.943-.94 0-1.881 0-1.881l.943-.941s.942-.94 1.885 0c.943.94 0 1.881 0 1.881l-.943.941Zm4.862.585s0-1.33 1.333-1.33 1.333 1.33 1.333 1.33v1.33s0 1.331-1.333 1.331-1.333-1.33-1.333-1.33v-1.331ZM11.999 18.628c3.682 0 6.666-2.979 6.666-6.653 0-3.674-2.984-6.653-6.666-6.653-3.682 0-6.667 2.979-6.667 6.653 0 3.674 2.985 6.653 6.667 6.653Z"
        fill="#FFAC33"
      />
    </Svg>
  )
)

SunIcon.propTypes = commonPropTypes
SunIcon.defaultProps = commonDefaultProps

export default SunIcon
